<template>
  <div id="ProjProNewRuleEdit">
    <ProjProNewHeader />
    <div class="panel-box">
      <ProjectViewSummary class="viewSummary" :project="project" />
      <div class="expand-icon-container">
        <i class="icon iconfont icon-piliangzengjia" @click="expandAll()"></i>
        <span @click="expandAll()">&nbsp;全部展开</span>
        &nbsp;
        <i class="icon iconfont icon-batch-reduce" @click="collapseAll()"></i>
        <span @click="collapseAll()">&nbsp;全部收起</span>
      </div>
    </div>
    <div class="eb-line"></div>
    <ProjRuleEditList ref="ruleEditList" :ruleList="ruleList" :uploadUrl="uploadUrl" />
    <div class="eb-button-group">
      <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="saveDraft()">保存草稿</el-button>
      <router-link class="eb-button-group-btn" :to="{path:'/projpro/new/info/'+ projectId}">
        <el-button class="eb-button-orange eb-button-big">&lt; 项目信息</el-button>
      </router-link>
      <router-link class="eb-button-group-btn" :to="{path:'/projpro/new/purchaselist/'+projectId}">
        <el-button class="eb-button-orange eb-button-big">采购清单 &gt;</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ProjProNewHeader from '@/components/project/pro/new/ProjProNewHeader';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import { baseURL } from '@/plugins/axios.js';
import EventBus from '@/plugins/event-bus';
import { listRule, editRule } from '@/services/proj/pro-rule-service';
import { handleProjRulelList } from '@/services/proj/project-service';

import ProjRuleEditList from '@/components/project/common/ruleedit/ProjRuleEditList';
import { getProjectById } from '@/services/proj/pro-project-service';

export default {
  name: 'ProjProNewRuleEdit',
  components: {
    ProjProNewHeader,
    ProjectViewSummary,
    ProjRuleEditList
  },
  data() {
    return {
      user: this.$store.state.user.userInfo,
      projectId: this.$route.params.projectId,
      project: {},
      ruleList: [],
      uploadUrl: ''
    };
  },
  created() {
    this.getProjectById();
    this.listRule();

    // 修改规则列表
    EventBus.$on('projEditRule', async (params, done) => {
      params.ruleContent = JSON.stringify(params.ruleContent);
      params.updateId = this.user.userid;
      try {
        let { data } = await editRule(params);
        if (data.returnCode !== '01') {
          this.listRule();
          throw new Error('修改规则失败');
        }
        done.success(data);
      } catch (err) {
        this.$message.error(err.message);
        done.error(err);
      }
    });
  },
  methods: {
    async getProjectById() {
      let { data } = await getProjectById({ projectId: this.projectId });
      this.project = data.project;
      // 初始化规则编辑上传url
      this.uploadUrl =
        baseURL +
        '/api/project/upload_attachment?channel=pa-bid&date=' +
        moment(this.project.createTime).format('YYYYMMDD') +
        '&projectId=' +
        this.project.projectId;
    },
    async listRule() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listRule({ projectId: this.projectId });
        if (data.returnCode === '01') {
          this.ruleList = handleProjRulelList(data.ruleList);
        } else {
          throw new Error('加载规则模板规则列表失败');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
      this.$root.layout.isLoading = false;
    },
    saveDraft() {
      this.$message.success('保存项目规则成功！');
    },
    expandAll() {
      this.$refs.ruleEditList.expandAll();
    },
    collapseAll() {
      this.$refs.ruleEditList.collapseAll();
    }
  },
  beforeDestroy() {
    EventBus.$off('projEditRule');
  }
};
</script>

<style scoped lang="less">
#ProjProNewRuleEdit {
  .panel-box {
    position: relative;
    .expand-icon-container {
      position: absolute;
      right: 15px;
      top: 45px;
      .iconfont {
        cursor: pointer;
        color: tomato;
        font-size: 24px;
      }
      span {
        cursor: pointer;
        color: tomato;
        font-size: 14px;
        position: relative;
        top: -3px;
      }
    }
  }
}
</style>
